const pojazdCzesci = { t: 'Pojazd', name: 'pojazd', hint: { url: '/part_vehicle' }}
export default pojazdCzesci